// extracted by mini-css-extract-plugin
export default {"container":"_fbfebe41","label":"_df9344c0","bold":"_e35bf8e3"};